const routers = [
  {
    // 外协商
    path: '/outsourcecompany/list',
    name: 'outsourcecompany',
    component: () => import('@/views/modules/outsource/outsourcecompany/List.vue')
  },
  {
    // 外协单
    path: '/outsourceorder/list',
    name: 'outsourceorder',
    component: () => import('@/views/modules/outsource/outsourceorder/List.vue')
  },
  {
    // 送货数量查询
    path: '/deliverynumber/list',
    name: 'deliverynumber',
    component: () => import('@/views/modules/outsource/deliverynumber/List.vue')
  }
]
export default routers
